module.exports = __webpack_public_path__ + "img/Weapon_294.94639346.png";